import React from 'react';
import { Helmet } from 'react-helmet';

// Hooks.
import useMetadataLd from '../../hooks/useMetadataLd';

const LdMetadataHelmet = ({ children }) => {
  const metadataLd = useMetadataLd();

  return (
    <Helmet>
      {children}
      {metadataLd &&
        metadataLd.map((item, i) => (
          <script key={i} type="application/ld+json">
            {item}
          </script>
        ))}
    </Helmet>
  );
};

export default LdMetadataHelmet;
